/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type OverviewRoot_viewer = {
    readonly tradePortfolioInstagram: boolean | null;
    readonly tradeFirms?: ReadonlyArray<{
        readonly publicProfile: {
            readonly articles: ReadonlyArray<{
                readonly webLink: {
                    readonly url: string | null;
                } | null;
            } | null> | null;
        } | null;
        readonly instagram: {
            readonly __id: string;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"OverviewAbout_tradeFirm" | "OverviewAwards_tradeFirm" | "OverviewArticles_tradeFirm" | "OverviewWeblinks_tradeFirm" | "OverviewInstagram_tradeFirm" | "OverviewFavorites_tradeFirm" | "OverviewProjects_tradeFirm">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"OverviewInstagram_viewer" | "OverviewAwards_viewer">;
    readonly " $refType": "OverviewRoot_viewer";
};
export type OverviewRoot_viewer$data = OverviewRoot_viewer;
export type OverviewRoot_viewer$key = {
    readonly " $data"?: OverviewRoot_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"OverviewRoot_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "firmUrlLabel"
    },
    {
      "kind": "RootArgument",
      "name": "shouldRenderOverview"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "OverviewRoot_viewer",
  "selections": [
    {
      "alias": "tradePortfolioInstagram",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "tradePortfolioInstagram"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"tradePortfolioInstagram\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OverviewInstagram_viewer"
    },
    {
      "condition": "shouldRenderOverview",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "urlLabel",
              "variableName": "firmUrlLabel"
            }
          ],
          "concreteType": "TradeFirmType",
          "kind": "LinkedField",
          "name": "tradeFirms",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmPublicProfileType",
              "kind": "LinkedField",
              "name": "publicProfile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DesignFirmArticleType",
                  "kind": "LinkedField",
                  "name": "articles",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WebLink",
                      "kind": "LinkedField",
                      "name": "webLink",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "url",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "InstagramFeedType",
              "kind": "LinkedField",
              "name": "instagram",
              "plural": false,
              "selections": [
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__id",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "OverviewAbout_tradeFirm"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "OverviewAwards_tradeFirm"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "OverviewArticles_tradeFirm"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "OverviewWeblinks_tradeFirm"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "OverviewInstagram_tradeFirm"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "OverviewFavorites_tradeFirm"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "OverviewProjects_tradeFirm"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OverviewAwards_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '1b15bcd3e523c274ef132d80815eca2d';
export default node;
